import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import {
  GET_API_ZATCA_TRANSACTION_DETAIL,
  GET_API_ZATCA_TRANSACTION_DETAIL_ROW_JSON,
  GET_API_ZATCA_TRANSACTION_SUMRY,
} from "../../Server/ApiV2";


const ZatcaTransactionSummaryApi = async (payload) => {
  try {
    let FinalObj = fcheck_null_undefine_replace_empty(payload);
    const Res = await GET_API_ZATCA_TRANSACTION_SUMRY(FinalObj);
    if (Res?.status === 200) {
      return Res;
    }
  } catch (error) {}
};
const ZatcaTransactionDetailApi = async (payload) => {
  try {
    let FinalObj = fcheck_null_undefine_replace_empty(payload);
    const Res = await GET_API_ZATCA_TRANSACTION_DETAIL(FinalObj);
    if (Res?.status === 200) {
      return Res;
    }
  } catch (error) {}
};
const ZatcaTransactionDetailRowJsonApi = async (payload) => {
  try {
    let FinalObj = fcheck_null_undefine_replace_empty(payload);
    const Res = await GET_API_ZATCA_TRANSACTION_DETAIL_ROW_JSON(FinalObj);
    if (Res?.status === 200) {
      return Res;
    }
  } catch (error) {}
};

export {
  ZatcaTransactionSummaryApi,
  ZatcaTransactionDetailApi,
  ZatcaTransactionDetailRowJsonApi,
};
